<template>

    <div 
        id="optimize99-ab-test-editor" 
        class="optimize99-ab-test-editor"
        ref="editor"
        v-show="is_show"
    >
        <!-- {{selected_element_selector}}
        {{step}} -->
        <div 
            ref="editor-header"
            class="d-flex justify-end align-center optimize99-ab-test-editor-header"
            @mousedown="moveEditor"
            :key="step_history_index"
        >
            <!-- {{step_history_index}} -->
            <!-- 上一步 -->
            <v-btn
                v-if="step.base.attribute.src"
                :disabled="step_history_index === -1"
                class="d-flex align-center"
                @click="handleHistory('previous')"
                icon
                
            >
                <v-icon
                    icon
                    class="optimize99-ab-test-editor-header-icon"
                    color="#FFF"
                >
                    mdi-arrow-u-left-top
                </v-icon>
            </v-btn>

            <!-- 下一步 -->
            <v-btn
                v-if="step.base.attribute.src"
                class="d-flex align-center"
                icon
                :disabled="(step_historys.length === 0 || step_history_index === step_historys.length - 1)"
                @click="handleHistory('next')"
            >
                <v-icon
                    class="optimize99-ab-test-editor-header-icon"
                    color="#FFF"
                >
                    mdi-arrow-u-right-top
                </v-icon>
            </v-btn>

            <!-- 縮小tool bar -->
            <!-- <v-btn
                class="d-flex align-center"
                icon
                @click="closeEditor"
            >
                <v-icon 
                    class="optimize99-ab-test-editor-header-icon"
                    color="#FFF"
                >
                    mdi-minus
                </v-icon>
            </v-btn> -->

        </div>

        <div 
            class="optimize99-ab-test-editor-tool"
            ref="optimize99-ab-test-editor-tool"
        >
            <div class="mt-3">
                <v-btn
                    v-if="!step.base.attribute.src"
                    color="#5087e6"
                    block
                    class="white--text"
                    @click="startEdit('', '', '')"
                >
                    建立動畫
                </v-btn>
                <!-- <v-btn
                    v-if="!step.base.attribute.src"
                    color="red"
                    class="white--text mt-3"
                    block
                    @click="backEditor"
                >
                    返回編輯
                </v-btn> -->
                <!-- <v-btn
                    v-if="!step.base.attribute.src"
                    color="red"
                    class="white--text mt-3"
                    block
                    @click="backEditor"
                >
                    返回編輯
                </v-btn> -->
                <!-- <v-btn
                    v-if="!step.base.attribute.src"
                    color="red"
                    class="white--text mt-3"
                    block
                    @click="backEditor"
                >
                    返回編輯
                </v-btn> -->
                <!-- <v-btn
                    v-if="!step.base.attribute.src"
                    color="purple"
                    block
                    class="white--text mt-4"
                    @click="uploadImg('init')"
                >
                    插入動畫
                </v-btn> -->
                <v-btn
                    v-if="step.base.attribute.src"
                    color="red"
                    class="white--text"
                    block
                    @click="removeAnimation"
                >
                    移除動畫
                </v-btn>

                <!-- <v-btn
                    v-if="step.base.attribute.src"
                    color="success"
                    class="white--text mt-3"
                    block
                    @click="finishAnimation"
                >
                    完成編輯
                </v-btn> -->
            </div>
            <div v-if="step.base.attribute.src">
                <section>
                    <h2 class="optimize99-ab-test-editor-block-title"
                    >
                       底圖
                    </h2>

                    <v-expansion-panels
                        v-model="active_bgs"
                    >
                        <v-expansion-panel
                            @click="hightlightBg"
                        >
                            <v-expansion-panel-header
                                class="pa-1"
                            >
                                <!-- {{active_bgs}} -->
                                <div
                                    style="width:100%; order:1;"
                                    class="d-flex "
                                >
                                    <v-img
                                        v-if="step.base.attribute"
                                        contain
                                        max-height="60"
                                        max-width="60"
                                        min-height="60"
                                        min-width="60"
                                        :src="step.base.attribute.src"
                                        class="pl-2 fit-image"
                                    ></v-img>
                                    <v-skeleton-loader
                                        v-else
                                        type="image"
                                        class="pl-2"
                                    ></v-skeleton-loader>

                                    <div
                                        class="animation-detail d-flex align-center justify-space-between"
                                        style="width:100%;"
                                    >   
                                        <div>
                                            <div>{{getAnimation(step.base.attribute['data-aos'], animation_fields.params, 'data-aos' )}}</div>
                                            <div v-if="step.base.attribute['data-aos-delay']">延遲: {{getSec(step.base.attribute['data-aos-delay'])}} 秒</div>
                                            <div v-if="step.base.attribute['data-keep-animation']">
                                                {{getAnimation(step.base.attribute['data-keep-animation'], animation_fields.params, 'data-keep-animation')}}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </v-expansion-panel-header>
                            <v-expansion-panel-content
                                class="pl-2 pr-2 pb-4 panel-content"
                            >
                                <div
                                    v-for="(param, idx) in animation_fields.params"
                                    :key="idx"
                                >
                                    <h2 class="optimize99-ab-test-editor-field-title"
                                    >
                                        {{param.name}}
                                    </h2>

                                    <template v-if="param.type === 'text'">
                                        <v-text-field
                                            outlined
                                            dense
                                            hide-details
                                            v-model="step.base.attribute[param.key]"
                                            @change="updateAttribute(step.base.bk_attribute[param.key], param.key, step.base.attribute[param.key], step.base.selector)"
                                        >

                                        </v-text-field>
                                    </template>
                                    
                                    <template v-if="param.type === 'number'">
                                        <v-text-field
                                            type="number"
                                            :min="param.min"
                                            :max="param.max"
                                            outlined
                                            dense
                                            hide-details
                                            v-model="step.base.attribute[param.key]"
                                            @change="updateAttribute(step.base.bk_attribute[param.key], param.key, step.base.attribute[param.key], step.base.selector)"
                                        >

                                        </v-text-field>
                                    </template>

                                    <template v-if="param.type === 'select'">
                                        <v-select
                                            outlined
                                            dense
                                            hide-details
                                            :items="param.items"
                                            v-model="step.base.attribute[param.key]"
                                            @change="updateAttribute(step.base.bk_attribute[param.key], param.key, step.base.attribute[param.key], step.base.selector)"
                                        >
                                        </v-select>
                                    </template>    
                                </div>    
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                        <!-- <div 
                            style="width:100%;"
                            class="d-flex justify-space-between"
                        >

                            <div>

                            </div>
                            <v-btn
                                icon
                                @click="editAnimation"
                            >
                                <v-icon>
                                    mdi-pencil
                                </v-icon>
                            </v-btn>
                        </div> -->
                </section>
            </div>

            <div v-if="step.base.attribute.src">

                <section>
                    <h2 class="optimize99-ab-test-editor-block-title"
                    >
                       圖層
                    </h2>
                    <div 
                        class="pt-2 pb-4"
                    > 
                        <v-btn
                            color="purple"
                            dark
                            block
                            @click="uploadImg"
                        >
                            新增圖層
                        </v-btn>
                    </div>

                    <v-expansion-panels
                        v-model="active_layers"
                    >
                        <!-- {{active_layers}} -->
                        <v-expansion-panel
                            v-for="(layer, idx) in step.layers"
                            :key="idx"
                            @click="hightLightLayer(layer, idx)"
                        >
                            <v-expansion-panel-header
                                class="pa-1"
                            >
                            
                                <div
                                    style="width:100%; order:1;"
                                    class="d-flex"
                                >
                                    <v-img
                                        v-if="layer.attribute.src"
                                        contain
                                        max-height="60"
                                        max-width="60"
                                        min-height="60"
                                        min-width="60"
                                        :src="layer.attribute.src"
                                        class="pl-2 fit-image"
                                    ></v-img>
                                    <v-skeleton-loader
                                        v-else
                                        type="image"
                                    ></v-skeleton-loader>

                                    <div
                                        class="animation-detail d-flex align-center justify-space-between"
                                    >
                                        <div>
                                            <div>{{getAnimation(layer.attribute['data-aos'], animation_fields.params, 'data-aos' )}}</div>
                                            <div v-if="layer.attribute['data-aos-delay']">
                                                延遲: {{getSec(layer.attribute['data-aos-delay'])}} 秒
                                            </div>
                                            <div v-if="layer.attribute['data-keep-animation']">
                                                {{getAnimation(layer.attribute['data-keep-animation'], animation_fields.params, 'data-keep-animation')}}
                                            </div>
                                        </div>


                                        <div>
                                            <v-btn icon
                                                @click.stop="removeLayer(layer)"
                                            >
                                                <v-icon>mdi-trash-can-outline</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>


                            </v-expansion-panel-header>
                            <v-expansion-panel-content
                                class="pl-2 pr-2 pb-4 panel-content"
                            >
                                <div
                                    v-for="(param, idx) in animation_fields.params"
                                    :key="idx"
                                >
                                    <h2 class="optimize99-ab-test-editor-field-title"
                                    >
                                        {{param.name}}
                                    </h2>

                                    <template v-if="param.type === 'text'">
                                        <v-text-field
                                            outlined
                                            dense
                                            hide-details
                                            v-model="layer.attribute[param.key]"
                                            @change="updateAttribute(layer.bk_attribute[param.key], param.key, layer.attribute[param.key], layer.attribute['animation-thing-key'])"
                                        >

                                        </v-text-field>
                                    </template>
                                    
                                    <template v-if="param.type === 'number'">
                                        <v-text-field
                                            type="text"
                                            :min="param.min"
                                            :max="param.max"
                                            outlined
                                            dense
                                            hide-details
                                            v-model="layer.attribute[param.key]"
                                            @change="updateAttribute(layer.bk_attribute[param.key], param.key, layer.attribute[param.key], `[animation-thing-key='${layer.attribute['animation-thing-key']}']`)"
                                        >

                                        </v-text-field>
                                    </template>

                                    <template v-if="param.type === 'select'">
                                        <v-select
                                            outlined
                                            dense
                                            hide-details
                                            :items="param.items"
                                            v-model="layer.attribute[param.key]"
                                            @change="updateAttribute(layer.bk_attribute[param.key], param.key, layer.attribute[param.key], `[animation-thing-key='${layer.attribute['animation-thing-key']}']`)"
                                        >
                                        </v-select>
                                    </template>    
                                </div> 

                                <template
                                    v-for="(param, idx) in animation_fields.styles"
                                    
                                >
                                    <div
                                        :key="`s-${idx}`"
                                        v-if="param.is_show"
                                    >   
                                        <h2 class="optimize99-ab-test-editor-field-title"
                                        >
                                            {{param.name}}
                                        </h2>

                                        <template v-if="param.type === 'text'">
                                            <v-text-field
                                                outlined
                                                dense
                                                hide-details
                                                v-model="layer.css[param.key]"
                                                @change="updateStyle(layer.bk_css[param.key], param.key, layer.css[param.key], layer.attribute['animation-thing-key'])"
                                            >

                                            </v-text-field>
                                        </template>
                                        
                                        <template v-if="param.type === 'number'">
                                            <v-text-field
                                                type="text"
                                                :min="param.min"
                                                :max="param.max"
                                                outlined
                                                dense
                                                hide-details
                                                v-model="layer.css[param.key]"
                                                @change="updateStyle(layer.bk_css[param.key], param.key, layer.css[param.key], `[animation-thing-key='${layer.attribute['animation-thing-key']}']`)"
                                            >

                                            </v-text-field>
                                        </template>

                                        <template v-if="param.type === 'select'">
                                            <v-select
                                                outlined
                                                dense
                                                hide-details
                                                :items="param.items"
                                                v-model="layer.css[param.key]"
                                                @change="updateStyle(layer.bk_css[param.key], param.key, layer.css[param.key], `[animation-thing-key='${layer.attribute['animation-thing-key']}']`)"
                                            >
                                            </v-select>
                                        </template>  
                                    </div>
                                </template>


                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                </section>
                
            </div>
        </div>
    </div>
    
</template>

<script>
import animation_fields from '@/static/animation_fields.json'
import { eventBus } from '@/event_bus.js';
import { mapMutations,mapGetters  } from 'vuex'
import store from '@/store';

    export default {
        name: 'AnimactionEditor',
        props: {
            vid: String,
            init_step_historys: Array,
            init_step_history_index: Number,
        },
        data() {
            return {
                is_drag: false,
                offsetX: 0,
                offsetY: 0,
                tmp_left: 0,
                tmp_top: 0,
                is_show: false,
                upload_base_dialog: false,
                original_info: null,
                selected_element_selector: null,
                selected_element_info: null,
                step: {
                    type: 'animation',
                    base: {
                        info: {},
                        attribute: {},
                        selector: '[animation-bg]',
                    },
                    layers: [],
                },
                animation_fields: animation_fields,
                active_layers: [],
                active_bgs: [],
                step_historys: [],
                step_history_index: -1,
            }
        },
        created(){
            console.log('an_init_step_history_index',this.init_step_history_index)
            eventBus.$on('update-editor-ele', this.updateEditorEle);
            eventBus.$on('update-editor-history', this.updateHistory);
            this.step_historys = this.init_step_historys
            this.step_history_index = this.init_step_history_index
        },
        destroyed: function(){
            eventBus.$off('update-editor-ele', this.updateEditorEle);
        },
        mounted(){
            let dragElement = this.$refs['editor']
            let that = this

            // 要可以移動
            document.addEventListener('mousemove', function(e) {
                if (that.is_drag) {
                    dragElement.style.left = (e.clientX - that.offsetX) + 'px'
                    dragElement.style.top = (e.clientY - that.offsetY) + 'px'
                }
            });

            document.addEventListener('mouseup', function() {
                that.is_drag = false;
            });
        },
        methods: {
            moveEditor: function(e){
                let that = this;
                let dragElement = this.$refs['editor']
                that.is_drag = true
                // that.$store.commit('setIsOpenOverlay', true)
                that.offsetX = e.clientX - dragElement.offsetLeft;
                that.offsetY = e.clientY - dragElement.offsetTop;
            },

            init(original_info, selected_element_selector, selected_element_info, plugin_param){
                console.log('ani-', original_info)
                console.log('ani-', selected_element_selector)
                console.log('ani-', selected_element_info)
                console.log('ani-', plugin_param)
                this.selected_element_info = selected_element_info
                this.selected_element_selector = selected_element_selector
                this.original_info = original_info
                // 確認有沒有選擇元素
                // 沒有請他先選元素
                if (!selected_element_selector) {
					this.$root.vtoast.show({
						message: '請先選擇網頁元素。'
					})
                    return
                }
                // 有的話確認是不是圖片
                // 是圖片問是否用這個當底圖
                if (selected_element_selector.includes('opt99-plugin="animation"]')) {
                    this.is_show = true
                    if (plugin_param) {
                        this.step.base.attribute = plugin_param.base.attribute
                        this.step.layers = plugin_param.layers
                    }
                    eventBus.$emit('edit-text', true, {
                        selector: this.selected_element_selector,
                        selected_element_info: this.selected_element_info,
                        type: 'AnimationEditor',
                    })
                    return
                }
            
                if (selected_element_info.nodeName === 'IMG') {
                    this.is_show = true
                    eventBus.$emit('edit-text', true, {
                        selector: this.selected_element_selector,
                        selected_element_info: this.selected_element_info,
                        type: 'AnimationEditor',
                    })
                    // let dialog_setting = {
                    //     alert_type: {
                    //         is_show: false,
                    //         type: 'warning',
                    //         color: 'orange',
                    //         icon: 'mdi-alert-outline'
                    //     },
                    //     is_show: true,
                    //     title: '系統訊息',
                    //     text: "要使用目前選擇的圖片當作底圖，還是另外再選擇圖片？",
                    //     html: '',
                    //     btns: [
                    //         {
                    //             text: '目前選擇的圖片',
                    //             callback: this.startEdit,
                    //             color: "grey"
                    //         },
                    //         {
                    //             text: '另外選擇',
                    //             callback: this.uploadImg,
                    //             color: "primary"
                    //         },
                    //     ],
                    //     data: 'init'
                    // }
                    // eventBus.$emit('open-dialog', dialog_setting);
                }
                else {
					this.$root.vtoast.show({
						message: '請選擇圖片。'
					})
                    return
                    // this.uploadImg()
                }
                
            },
            async startEdit(img_src, target_element_selector, method){
                
                if (!img_src || img_src === 'init') {
                    img_src = this.selected_element_info.attributes.src
                }
                if (!target_element_selector) {
                    target_element_selector = this.selected_element_selector
                }
                if (!method) {
                    method = 'replace'
                }
                console.log('畫布底圖', img_src)
                console.log('畫布目標', target_element_selector)
                console.log('畫布初始方法', method)
                let tmp_id = `tmp-${new Date().getTime()}`
                let wrapper_html = `
                    <div 
                        style="position:relative;" 
                        opt99-cid="${this.$route.params.container_id}" 
                        opt99-plugin="animation"
                        opt99-vid="${this.vid}"
                        opt99-id="${tmp_id}"
                    >
                        <div
                            animation-bg
                            data-aos=""
                            data-aos-once="false"
                            src="${img_src}"
                            class="aos-animate"
                        >
                            <img
                                src="${img_src}"
                            />
                        </div>

                    </div>
                `
                console.log('wrapper_html',wrapper_html)
                let data = {
                    type: "init_animation",
                    selector: target_element_selector,
                    original_info: this.original_info,
                    value: this.selected_element_info.outerHtml,
                    new_value: wrapper_html,
                    method: method,
                    need_new_ele: true
                }
                console.log('init_animation_params', data)
                await eventBus.$emit('update-selected-element', data, 'next');
                this.recordHistory(data)
                eventBus.$emit('open-dialog', {
                    is_show: false
                });

                this.step.base.attribute.src = img_src
                this.is_show = true
            },
            uploadImg(upload_type){
                console.log('upload_img', upload_type)
                eventBus.$emit('open-dialog', {
                    is_show: false
                });
                this.$emit('callback', {
                    name: 'uploadImg',
                    upload_type: upload_type,
                })
            },
            async insertLayer(img_src, target_element_selector){
                console.log('insertLayer', img_src)
                console.log('insertLayer', target_element_selector)
                let html = `
                    <div
                        animation-thing
                        style="position:absolute;top:0px;left:0px;height:50%;" 
                        animation-thing-key="${new Date().getTime()}"
                        src="${img_src}" 
                    >
                        <img 
                            src="${img_src}"   
                        />
                    </div>
                `
                let data = {
                    type: "html",
                    selector: target_element_selector,
                    original_info: this.original_info,
                    value: this.selected_element_info.outerHtml,
                    new_value: html,
                    method: 'beforeend',
                    edit_from: 'animation'
                }
                await eventBus.$emit('update-selected-element', data, 'next');
                this.recordHistory(data)
                this.is_show = true
            },
            updateEditorEle: function(data){
                console.log('animation-editor', data)

                if (!data.plugin_type) {
                    this.is_show = false
                    store.commit('optimize/SET_EDITOR', 'Editor')
                    return
                }

                this.original_info = JSON.parse(JSON.stringify(data.selected_element_info))
                this.selected_element_selector = data.selected_element_selector
                this.selected_element_info = data.selected_element_info

                let tmp = JSON.parse(JSON.stringify(data))
                this.step.info = tmp
                this.step.base.attribute = tmp.plugin_param.base.attribute
                this.step.base.bk_attribute = JSON.parse(JSON.stringify(tmp.plugin_param.base.attribute))
                this.step.layers = tmp.plugin_param.layers
                this.step.layers.forEach(layer => {
                    Object.keys(layer).forEach(param_type => {
                        layer[`bk_${param_type}`] = JSON.parse(JSON.stringify(layer[param_type]))
                    })
                })
                console.log('layers', this.step.layers)
                this.is_show = true

                console.log('this.step.base.attribute',this.step.base.attribute)
            },
            editAnimation(){
                console.log('show_animation_dialog')
            },
            getSec(millisecond){
                let format = ''
                if (millisecond) {
                    format = millisecond / 1000
                }
                return format
            },
            getAnimation(animation_name, params, find_key) {
                let name = ''
                if (animation_name) {
                    let keep_animation = params.find(param => {
                        return param.key === find_key
                    })
                    name = keep_animation.items.find(param => {
                        return param.value === animation_name
                    })
                    if (name) {
                        name = name.text
                    }
                }
                return name
            },
            updateAttribute(old_val, attribute_name, new_val, layer_selector){
                console.log("old_val", old_val)
                console.log("attribute_name", attribute_name)
                console.log('new_val', new_val)
                console.log('layer_selector',layer_selector)
                let selector = `${this.selected_element_selector} ${layer_selector}`
                let data = {
                    type: "attribute",
                    selector: selector,
                    attribute: attribute_name,
                    original_info: this.original_info,
                    value: old_val,
                    new_value: new_val,
                    vid: this.vid,
                    edit_from: 'animation'
                }
                console.log('data',data)
                eventBus.$emit('update-selected-element', data, 'next');
                this.recordHistory(data)
            },
            updateStyle(old_val, css_name, new_val, layer_selector){
                let data = {
                    type: "css",
                    selector: layer_selector,
                    css: css_name,
                    value: old_val,
                    new_value: new_val,
                }
                
                eventBus.$emit('update-selected-element', data, 'next');
            },
            async removeLayer(item){
                console.log('item', item)
                console.log('selector', this.selected_element_selector)
                console.log('origial_info', this.original_info)
                let selector = `[animation-thing-key="${item.attribute['animation-thing-key']}"]`
                let wrapper_ele = this.$utils.createDomByHtmlString(this.original_info.outerHtml)
                let target = wrapper_ele.querySelector(selector)
                target.remove()
                console.log('wrapper_ele', wrapper_ele)

                let data = {
                    type: "html",
                    selector: this.selected_element_selector,
                    original_info: this.original_info,
                    value: this.original_info.outerHtml,
                    new_value: wrapper_ele.outerHTML,
                    method: 'replace',
                    edit_from: 'animation'
                }
                await eventBus.$emit('update-selected-element', data, 'next');
                this.recordHistory(data)

            },
            hightLightLayer(item, idx){
                console.log('item', item)
                console.log('idx', idx)
                let selector = `${this.selected_element_selector} [animation-thing-key="${item.attribute['animation-thing-key']}"]`
                let data = {
                    type: "highlight_layer",
                    selector: selector,
                }
                eventBus.$emit('update-selected-element', data, 'next');
                this.active_bgs = undefined
                // 邏輯在htmlHelper.js  highlight_layer
            },
            handleHistory: async function(step_type){
                let idx = this.step_history_index

                if (step_type === 'next') {
                    console.log('下一步')
                    idx += 1
                }
                else {
                    console.log('上一步')
                }
                
                const ele = this.step_historys[idx]
                console.log('idx', idx)
                console.log('ele', ele)
                
                
                if (step_type !== 'next') {
                    this.step_history_index = idx - 1
                    await eventBus.$emit('update-header-history', this.step_historys, this.step_history_index);
                    await eventBus.$off('update-editor-history', this.updateHistory);
                    await eventBus.$emit('update-editor-history', this.step_historys, this.step_history_index);
                    eventBus.$on('update-editor-history', this.updateHistory);
                }
                else {
                    this.step_history_index = idx
                    await eventBus.$emit('update-header-history', this.step_historys, this.step_history_index); 
                    await eventBus.$off('update-editor-history', this.updateHistory);
                    await eventBus.$emit('update-editor-history', this.step_historys, this.step_history_index);
                    eventBus.$on('update-editor-history', this.updateHistory);
                }
                eventBus.$emit('update-selected-element', ele, step_type, true);
                console.log('ani-handle history', this.step_history_index)
            
            },
            recordHistory: function(data){

                let step_historys = this.step_historys
                let idx = this.step_history_index

                // 把目前這index當作最新的，之後的全刪掉
                step_historys.splice(idx + 1, step_historys.length - idx - 1)
                // 推進去歷史紀錄
                step_historys.push(data)
                idx = step_historys.length - 1

                eventBus.$emit('update-header-history', step_historys, idx);
                this.step_historys = step_historys 
                this.step_history_index = idx
            },
            updateHistory: function(historys, history_idx){
                this.step_historys = historys
                this.step_history_index = history_idx
            },
            async removeAnimation(){
                console.log('history', this.step_historys)
                console.log('removeAnimation', this.step)
                console.log('selected_element_info', this.selected_element_info)
                console.log('selected_element_selector', this.selected_element_selector)

                let animation_id = ''
                const match = this.selected_element_selector.match(/opt99-id="([^"]+)"/);

                if (match) {
                    animation_id = match[1];
                    console.log(animation_id); 
                    let original_history = this.step_historys.find(step_history => {
                        return step_history.type === 'init_animation' && step_history.new_value.includes(animation_id)
                    })
                    console.log('original_history', original_history)
                    let step = JSON.parse(JSON.stringify(original_history)) 
                    step.new_value = step.value
                    step.value = this.selected_element_info.outerHtml
                    step.type = 'remove_animation'
                    step.selector = this.selected_element_selector
                    step.need_new_ele = true
                    await eventBus.$emit('update-selected-element', step, 'next');
                    store.commit('optimize/SET_EDITOR', 'Editor')
                    // this.recordHistory(step)
                } 
                else {
                    console.log('opt99-id not found');
                }

            },
            async hightlightBg(){
                if (this.active_layers !== undefined) {
                    let layer = this.step.layers[this.active_layers]
                    if (layer) {
                        let selector = `${this.selected_element_selector} [animation-thing-key="${layer.attribute['animation-thing-key']}"]`
                        let data = {
                            type: "highlight_layer",
                            selector: selector,
                        }
                        await eventBus.$emit('update-selected-element', data, 'next');
                    }

                }
                this.active_layers = undefined

                console.log('hightligth_bg', this.active_bgs)
                console.log('hightlight_layer', this.active_layers)
                console.log('selector', this.selected_element_selector)
            },
            backEditor(){
                console.log('backEditor', 'QAQ')
            },
            ...mapMutations('optimize', ['setEditor']),
        },
        computed: {
            ...mapGetters('optimize',[
                'catch_iframe_selected_data',
            ])
        },
    }
</script>

<style scoped>
    .theme--light.v-btn.v-btn--disabled, .theme--light.v-btn.v-btn--disabled .v-icon  {
        color: rgba(255,255,255,.26)!important;
    }
    .v-application p {
        margin-bottom: 0px;
    }
    .optimize99-ab-test-editor {
        background-color: white;
        bottom: 15px;
        border-radius: 2px;
        height: 500px;
        position: fixed;
        right: 15px;
        width: 280px;
        z-index: 3;
        box-shadow: 0 6px 6px -3px rgb(0 0 0 / 20%), 0 10px 14px 1px rgb(0 0 0 / 14%), 0 4px 18px 3px rgb(0 0 0 / 12%);
    }
    .optimize99-ab-test-editor.optimize99-ab-test-editor-edit-mode {
        height: fit-content;
        width: auto;
        padding: 10px;
    }
    .optimize99-ab-test-editor-header {
        border-radius: 2px 2px 0 0;
        padding: 0 0.5em;
        min-height: 50px;
        position: relative;
        background-color: rgb(26,115,232);
        color: rgb(255,255,255);
    }
    .optimize99-ab-test-editor-header.plugin {
        background-color: #9c27b0 !important
    }
    .optimize99-ab-test-editor-header-icon {
        font-size: 20px !important;
        cursor: pointer;
    }
    .optimize99-ab-test-editor-tool{
        padding: 0 16px 16px;
        overflow-y: scroll;
        height: 450px;
    }
    .optimize99-ab-test-editor-block-title {
        color: rgba(0,0,0,.7);
        font-size: 15px;
        font-weight: 500;
        margin:13px 0px 6px 0px !important;
        padding: 0px;
    }

    .optimize99-ab-test-editor-field-title {
        color: rgba(0,0,0,.4);
        font-size: 13px;
        font-weight: 500;
        margin:13px 0px 6px 0px !important;
        padding: 0px;
    }
    .optimize99-ab-test-editor-field {
        display: flex;
        flex-direction: row;
        align-items: center;
        max-width: 100%;
        padding:2px 0px;
        position: relative;
    }
    .optimize99-ab-test-editor-field > i, .optimize99-ab-test-editor-field > span {
        color: rgba(0,0,0,0.54);
        margin-right: 0.5em;
        
    }
    .optimize99-ab-test-editor-field-input {
        width: 9em;
        max-width: 100%;
        line-height: 1em;
    }
    .animation-detail {
        width: 100%;
        padding: 0px 0px 0px 3px; 
    }
    .animation-detail > div {
        padding: 0px 0px 3px 0px;
        font-size: 14px;
    }
    .panel-content >>> .v-expansion-panel-content__wrap {
        padding: 0px;
    }
    .fit-image >>> .v-image__image--contain{
        background-size: cover;
    }
</style>